import {
  textToFilter
} from "./chunk-45SK4NFQ.js";
import {
  getConfigWithMetadata
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// src/services/getFilterByAiPrompt/getFilterByAiPrompt.ts
async function getFilterByAiPrompt({ marketCountryCode, ...aiTextToFilterRequest }, apiConfig) {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, "getFilterByAiPrompt");
    const data = await textToFilter(aiTextToFilterRequest, { marketCountryCode }, _apiConfig);
    return {
      status: "success",
      data
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export {
  getFilterByAiPrompt
};
